//a shared confirmation dialog component
import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

import type {
  ConfirmationDialog,
  ConfirmationDialogOptions,
} from '@/shared/types/confirmationDialog';

const ConfirmationDialog: React.FC<ConfirmationDialogOptions> = ({
  open,
  title,
  message,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {/* Preflight zeroes margins on everything, so this paragraph's spacing has to
            be explicit. Not `DialogContentText`: the theme sets body1 to 1.1rem while
            a raw <p> inherits 1rem from CssBaseline, so switching would visibly
            enlarge the text in every confirmation dialog in the app. */}
        <Box component="p" sx={{ my: '1em' }}>
          {message}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {cancelButtonText}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
